module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/rule_frame-a27a876da3acb7b5ae94fca21d951953.png";